import { j as r } from "./index.es33.js";
import { Typography as p } from "./index.es35.js";
import "./index.es36.js";
import s from "./index.es575.js";

var l = function l(_ref) {
  var o = _ref.label,
      m = _ref.children;
  return r.jsxs(r.Fragment, {
    children: [r.jsx(p.Small, {
      as: "p",
      weight: "medium",
      className: s.groupHead,
      children: o
    }), m]
  });
};

export { l as OptionGroup };